import {useState} from "react";
import {Controller, useFormContext} from "react-hook-form";
import {CustomAutocomplete} from "ui";
import {AutoCompleteData} from "ui/CustomAutoComplete/CustomAutoComplete";
import useChangeDAteAndAutocomplete from "views/ProcessDetails/hooks/useChangeDAteAndAutocomplete";
import useValidateVoyages from "views/ProcessDetails/hooks/useValidateVoyages";
import {getLocationType} from "views/ProcessDetails/refactor/components/ProcessBoarding/components/VoyagesV2/utils/getLocationType";
import useHandleBoardingOptions from "views/ProcessDetails/refactor/components/ProcessBoarding/useHandleBoardingOptions";
import {Process} from "views/ProcessDetails/refactor/types/process.types";
import {Voyage} from "views/ProcessDetails/refactor/types/voyages.types";
import {ID_COLLECT_VOYAGE} from "views/ProcessDetails/utils/constants";
import {getTooltipText} from "views/ProcessDetails/utils/getTooltipText";

type Props = {
  index: number;
  disabled: boolean;
  voyage: Voyage;
  allVoyages: Voyage[];
  isAiProcess: boolean;
};

const VoyageDestinationField = (props: Props) => {
  const {index, disabled, voyage, allVoyages, isAiProcess} = props;
  const {control} = useFormContext<Process>();

  const {
    getOptions: getBoardingOptions,
    onBottomScroll: onBottomScrollBoarding,
    isLoadingOptions: isLoadingBoardingOptions,
  } = useHandleBoardingOptions();
  const {handleChangeAutocomplete, mountOptions} =
    useChangeDAteAndAutocomplete();

  const [boardingOptions, setBoardingOptions] = useState(
    [] as AutoCompleteData[],
  );
  const [searchFields, setSearchFields] = useState({
    vessels: "",
    origin: "",
    destination: "",
  });

  const {validateDestination} = useValidateVoyages();

  return (
    <Controller
      name={
        `boarding.voyages[${index}].destination` as `boarding.voyages.0.destination`
      }
      control={control}
      rules={{
        validate: (value) =>
          validateDestination(value as any, index, allVoyages as any),
      }}
      render={({field: {value}}) => (
        <CustomAutocomplete
          optionSecondaryContent
          fullWidth
          textFieldProps={{
            label: "Destino",
          }}
          name={`boarding.voyages[${index}].destination`}
          placeholder="Destino"
          tooltipText={getTooltipText(value?.name)}
          loading={isLoadingBoardingOptions}
          options={mountOptions(value, boardingOptions)}
          value={value?.name ?? ""}
          onOpen={() =>
            getBoardingOptions(
              setBoardingOptions,
              "",
              1,
              50,
              getLocationType(isAiProcess, voyage?.typeVoyage?.id),
            )
          }
          onInputChange={(e, value) => {
            if (e !== null) {
              setSearchFields((prev) => ({
                ...prev,
                destination: value,
              }));
              getBoardingOptions(
                setBoardingOptions,
                value,
                1,
                50,
                getLocationType(isAiProcess, voyage?.typeVoyage?.id),
              );
            }
          }}
          getNextPage={() => {
            onBottomScrollBoarding(
              setBoardingOptions,
              searchFields.destination,
              getLocationType(isAiProcess, voyage?.typeVoyage?.id),
            );
          }}
          onChange={(e, value) => {
            handleChangeAutocomplete(
              e,
              value,
              `boarding.voyages[${index}].destination`,
            );
            if (
              voyage?.typeVoyage?.id !== ID_COLLECT_VOYAGE &&
              index !== allVoyages?.length - 1
            ) {
              handleChangeAutocomplete(
                e,
                value,
                `boarding.voyages[${index + 1}].origin`,
              );
            }
          }}
          isOptionEqualToValue={(option, value) => value === option?.label}
          disabled={disabled}
        />
      )}
    />
  );
};

export default VoyageDestinationField;
